import { format } from 'date-fns';
import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  ma_kho: z.string().optional(),
  dien_giai: z.string().optional(),
  ma_vt: z.string().optional(),
  ma_khon: z.string().optional(),
  ma_vi_tri: z.string().optional(),
  ma_vi_trin: z.string().optional(),
  ma_lo: z.string().optional(),
  ma_don_vi: z.string().optional(),
  // Status and filter fields
  status: z.string().optional(),
  ma_unit: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const formSchema = z.object({
  ma_ngv: z.string().optional(),
  so_buoc: z.string().optional(),
  ma_gd: z.string().optional(),
  dien_giai: z.string().optional(),
  so_ct: z.string().optional(),
  ngay_ct: z.string().optional(),
  ma_nt: z.string().optional(),
  ty_gia: z.coerce.number().optional(),
  status: z.string().optional(),
  transfer_yn: z.boolean().optional(),
  ma_tthddt: z.string().optional(),
  ma_pttt: z.string().optional(),
  so_ct_hddt: z.string().optional(),
  lenh_dd: z.string().optional(),
  ngay_ct_hddt: z.string().optional(),
  so_ct2_hddt: z.string().optional(),
  ngay_dd: z.string().optional(),
  ma_mau_ct_hddt: z.string().optional(),
  nguoi_dd: z.string().optional(),
  viec_dd: z.string().optional(),
  so_hd_vc: z.string().optional(),
  ly_do_huy: z.string().optional(),
  ly_do: z.string().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  ma_ngv: '3',
  so_buoc: '',
  ma_gd: '',
  dien_giai: '',
  so_ct: '',
  ngay_ct: format(new Date(), 'yyyy-MM-dd'),
  ma_nt: '',
  ty_gia: 1,
  status: '3',
  transfer_yn: false,
  ma_tthddt: '',
  ma_pttt: '',
  so_ct_hddt: '',
  lenh_dd: '',
  ngay_ct_hddt: '',
  so_ct2_hddt: '',
  ngay_dd: '',
  ma_mau_ct_hddt: '',
  nguoi_dd: '',
  viec_dd: '',
  so_hd_vc: '',
  ly_do_huy: '',
  ly_do: ''
};
